var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31372 7.37231V20.5723C5.31372 21.4827 6.00918 22.2413 6.93645 22.2413H17.291C18.2183 22.2413 18.9137 21.4827 18.9137 20.5723V7.37231H5.31372Z",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 3.12427H5.62273C4.69545 3.12427 4 3.88289 4 4.79323V5.70358C4 6.61392 4.69545 7.37254 5.62273 7.37254H18.6045C19.5318 7.37254 20.2273 6.61392 20.2273 5.70358V4.79323C20.2273 3.88289 19.5318 3.12427 18.6045 3.12427Z",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8183 3.12414H9.40918V2.74483C9.40918 1.83448 10.1819 1 11.1865 1H13.1183C14.0455 1 14.8955 1.75862 14.8955 2.74483V3.12414H14.8183Z",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86816 9.95166V18.5999",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1135 9.95166V18.5999",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3591 9.95166V18.5999",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.bf1b3a8a24372be0766dfcadd664505d.svg";
export { ForwardRef as ReactComponent };